import { FC } from 'react';

import { Button, Modal } from 'antd';
import { ICreateArticleCategory } from 'common/types';
import { articleCategorySchema } from 'common/validation';
import { Form, FormInput } from 'components/Form';
import { ArticleCategoryModel } from 'store/article-categoriy-model';

import { ArticleCategoriesViewModel } from '../article-category-view-model';

import styles from './article-categories-modal.module.scss';

export interface IArticleCategoryModalProps {
  model: ArticleCategoriesViewModel;
  closeModal: () => void;
  isOpen: boolean;
  editableArticleCategory: ArticleCategoryModel | null;
}

export const ArticleCategoryModal: FC<IArticleCategoryModalProps> = ({
  model,
  closeModal,
  isOpen,
  editableArticleCategory,
}) => {
  const isUpdate = !!editableArticleCategory?.id;
  const eventText = isUpdate ? 'Update' : 'Create';

  const onSubmit = async (values: ICreateArticleCategory) => {
    const result = await model?.manageArticleCategory(
      editableArticleCategory?.id,
      values,
    );

    if (result) {
      closeModal();
    }
  };

  const cancel = () => closeModal();

  return (
    <Modal
      className={styles.modalWrapper}
      destroyOnClose
      open={isOpen}
      footer={null}
      onCancel={closeModal}
    >
      <span className={styles.title}>{eventText} article category</span>
      <div className={styles.formContainer}>
        <Form
          initialValues={{
            name: editableArticleCategory?.name,
          }}
          validation={articleCategorySchema}
          onSubmit={onSubmit}
        >
          <div className={styles.fields}>
            <FormInput
              required
              name="name"
              label="Name"
              className={styles.field}
            />

            <div className={styles.buttonWrapper}>
              <Button
                loading={editableArticleCategory?.loading}
                disabled={editableArticleCategory?.loading}
                type="primary"
                htmlType="submit"
                className={styles.button}
              >
                {eventText}
              </Button>
              <Button
                disabled={editableArticleCategory?.loading}
                onClick={cancel}
                type="default"
                className={styles.button}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};
